import { Typography, styled } from "@material-ui/core";

export const TitleText = styled(Typography)({
  color: "#011533",
  fontFamily: "'Inter', 'sans-serif'",
  fontSize: "18px",
  fontWeight: 700,
  // Dark mode (additive): only applies under the `.dark` root; light unchanged.
  ".dark &": {
    color: "hsl(var(--sds-foreground))",
  },
});
